import styled, { css } from 'react-emotion'
import { rem } from 'polished'
import { media } from '../styles/theme'

export const sectionStyles = css`
  margin-top: 60px;
  margin-bottom: 20px;

  ${media.greaterThan('small')`
    margin-top: 120px;
    margin-bottom: 80px;
  `};
`

export const Section = styled.section`
  ${sectionStyles};
`

export default Section
